"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.reverse.js");
require("core-js/modules/es.json.stringify.js");
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _Item = require("./Item");
var _constants = require("../../../utils/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const List = _ref => {
  let {
    idList = [],
    isSerial = false
  } = _ref;
  return (0, _react.useMemo)(() => {
    const size = idList.length * _constants.spaseBetweenModelsByCol;
    return idList.reverse().map((id, i, map) => /*#__PURE__*/_react.default.createElement(_Item.Item, {
      key: id,
      supplyId: id,
      isFirst: i === map.length - 1,
      isLast: i === 0,
      isSerial: isSerial,
      hasCirculation: isSerial ? i === 0 : true,
      position: isSerial ? [0, 0, -i * (_constants.ModelWidth[_paulCorePackage.constants.ComponentTypes.PwhSupply] + _constants.spaseBetweenModels)] : [_constants.spaseBetweenModelsByCol * i - size + _constants.spaseBetweenModelsByCol, 0, 0]
    }));
  }, [JSON.stringify(idList), isSerial]);
};
var _default = exports.default = List;